import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { config } from '../../../../../environments/config';
import { tokenNotExpired } from 'angular2-jwt';
@Injectable()
export class UploadFilesService {

    public apiUrl = config.API_ROOT;
    public headers: Headers = new Headers();
    public options: RequestOptions;
    public progress$: Observable<number>;
    public progress: number;
    public progressObserver: any;
    constructor(public http: Http, public router: Router) {
        this.progress = 0;
        if (tokenNotExpired()) {
            this.headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));
        }
        this.options = new RequestOptions({ headers: this.headers });
        this.progress$ = new Observable(observer => {
            this.progressObserver = observer;
        });
    }

    public updateAvatar(files: File[]): Observable<Response> {
        const url = `${this.apiUrl}/profile/avatar`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public getProfessiogram(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined) {
            params.append('id', String(id));
        }

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/customer-guides/${id}/download-professiogram`, options);
    }

    public updateProfessiogram(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/customer-guides/${id}/professiogram`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public getAttachmentProfileSurvey(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined) {
            params.append('id', String(id));
        }

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/list-document-profile-surveis/${id}/download-attachment`, options);
    }

    public updateAttachmentProfileSurvey(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/list-document-profile-surveis/${id}/attachment`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public updateAttachmentServiceOrder(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/synergo-service-order/${id}/attachment`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public getAttachmentDocumentProfileSurvey(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined) {
            params.append('id', String(id));
        }

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/document-profile-surveis/${id}/download-attachment`, options);
    }

    public updateAttachmentDocumentProfileSurvey(files: File[], id:number, citation_id: number, profile_survey_id: number, checklist_profile_survey_id: number, list_profile_survey_id: number,radication_id?:number): Observable<Response> {
        let url = `${this.apiUrl}/document-profile-surveis/`;

        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i], files[i].name);
            formData.append('citation_id', citation_id.toString());
            formData.append('profile_survey_id', profile_survey_id.toString());
            formData.append('checklist_profile_survey_id', checklist_profile_survey_id.toString());
            formData.append('list_profile_survey_id', list_profile_survey_id.toString());
            if(radication_id !== null && radication_id !== undefined)
                formData.append('radication_id', radication_id.toString());
        }

        // if (id) {
        //     url = `${this.apiUrl}/document-profile-surveis/${id}/attachment`;
        // }

        return this.http.post(url, formData, this.options);
    }

    public deleteAttachmentDocumentProfileSurvey(id:number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/document-profile-surveis/${id}`, { headers: this.headers } );
    }

    public deleteAttachmentServiceOrder(id:number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/synergo-service-order/${id}`, { headers: this.headers } );
    }

    public getFileSelection(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined) {
            params.append('id', String(id));
        }

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/customer-guides/${id}/file-selection`, options);
    }

    public updateFileSelection(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/customer-guides/${id}/file-selection`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file_selection', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public updateFileSelectionMultiple(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/customer-guides/${id}/file-selection-multiple`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file_selection', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public deleteAttachmentFileSelectionMultiple(id:number): Observable<Response> {
        return this.http.delete( `${this.apiUrl}/customer-guides/${id}/file-selection-multiple`, { headers: this.headers } );
    }
    public getServiceClientFileReport(id: number): Observable<Response> {
      let params: URLSearchParams = new URLSearchParams();

      if (id !== null && id !== undefined) {
          params.append('id', String(id));
      }

      const options = new RequestOptions({search: params, headers: this.headers});


      return this.http.get( `${this.apiUrl}/customer-guides/${id}/service-client-file-report`, options);
  }

    public updateServiceClientFileReport(files: File[], id: number): Observable<Response> {
      const url = `${this.apiUrl}/customer-guides/${id}/service-client-file-report`;
      const formData: FormData = new FormData();
      for (let i = 0; i < files.length; i++) {
          formData.append('service_client_file_report', files[i], files[i].name);
      }
      return this.http.post(url, formData, this.options);
  }

    public getFileProfileSurvey(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined) {
            params.append('id', String(id));
        }

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/profile-surveis/${id}/file-profile-survey`, options);
    }

    public updateFileProfileSurvey(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/profile-surveis/${id}/file-profile-survey`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file_profile_survey', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public getFileDescription(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined) {
            params.append('id', String(id));
        }

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/pqrs/${id}/file-description`, options);
    }

    public updateFileDescription(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/pqrs/${id}/file-description`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file_description', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public getFileAnswer_solution(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined) {
            params.append('id', String(id));
        }

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/pqrs/${id}/file-answer_solution`, options);
    }

    public updateFileAnswer_solution(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/pqrs/${id}/file-answer_solution`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file_answer_solution', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public updateFileImportCitation(files: File[]): Observable<Response> {
        const url = `${this.apiUrl}/citations/import-file`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public getFileTest(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined) {
            params.append('id', String(id));
        }

        const options = new RequestOptions({search: params, headers: this.headers});


        return this.http.get( `${this.apiUrl}/citations/${id}/file-test`, options);
    }

    public updateFileTest(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/citations/${id}/file-test`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file_test', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public getFileEquipment(id: number): Observable<Response> {
      let params: URLSearchParams = new URLSearchParams();

      if (id !== null && id !== undefined) {
          params.append('id', String(id));
      }

      const options = new RequestOptions({search: params, headers: this.headers});

      return this.http.get( `${this.apiUrl}/inspection-has-equipments/${id}/file-equipment`, options);
    }

    public updateFileEquipment(files: File, id: number): Observable<Response> {
        const url = `${this.apiUrl}/inspection-has-equipments/${id}/file-equipment`;
        const formData: FormData = new FormData();
        formData.append('file_equipment', files, files.name);
        return this.http.post(url, formData, this.options);
    }

    public getTheftFileEquipment(id: number): Observable<Response> {
        let params: URLSearchParams = new URLSearchParams();

        if (id !== null && id !== undefined) {
            params.append('id', String(id));
        }

        const options = new RequestOptions({search: params, headers: this.headers});

        return this.http.get( `${this.apiUrl}/theft-has-equipments/${id}/file-evidence`, options);
      }

      public updateTheftFileEquipment(files: File, id: number): Observable<Response> {
          const url = `${this.apiUrl}/theft-has-equipments/${id}/file-evidence`;
          const formData: FormData = new FormData();
          formData.append('file_evidence', files, files.name);
          return this.http.post(url, formData, this.options);
      }

      public getFileLocationStation(id: number): Observable<Response> {
      let params: URLSearchParams = new URLSearchParams();

      if (id !== null && id !== undefined) {
          params.append('id', String(id));
      }

      const options = new RequestOptions({search: params, headers: this.headers});


      return this.http.get( `${this.apiUrl}/thefts/${id}/file-location-station`, options);
    }

    public updateFileLocationStation(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/thefts/${id}/file-location-station`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file_location_station', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public attachmentUploadCitations(files: File[]): Observable<Response> {
        let url = `${this.apiUrl}/citations/import-file`;

        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i], files[i].name);

        }

        return this.http.post(url, formData, this.options);
    }
    public attachmentUploadSchedules(files: File[]): Observable<Response> {
        let url = `${this.apiUrl}/schedule-employees/import-file`;

        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i], files[i].name);

        }

        return this.http.post(url, formData, this.options);
    }
    public attachmentUploadWorkerCares(files: File[]): Observable<Response> {
        let url = `${this.apiUrl}/worker-cares/import-file`;

        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file', files[i], files[i].name);

        }

        return this.http.post(url, formData, this.options);
    }

    public updateFileObservations(files: File[], id: number): Observable<Response> {
        const url = `${this.apiUrl}/innovation/systems-requests/${id}/file-observations`;
        const formData: FormData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('file_observations', files[i], files[i].name);
        }
        return this.http.post(url, formData, this.options);
    }

    public updateAttachmentAssignedDocument(files: File[], id: number): Observable<Response> {
      const url = `${this.apiUrl}/systems-inventory/${id}/attachment`;

      const formData: FormData = new FormData();
      for (let i = 0; i < files.length; i++) {
          formData.append('document_assigned', files[i], files[i].name);
      }
      return this.http.post(url, formData, this.options);
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/upload-files/upload-files.service.ts